import { createElement, forwardRef } from 'rax';
import { useLocale } from './hooks';
export default function withLocale(Component, { name, defaultLocale }) {
    return forwardRef((props, ref) => {
        const locale = useLocale(name, props, defaultLocale);
        return <Component {...props} locale={locale} ref={ref}/>;
    });
}
